import Error from "react/components/Error";

export function NotFound() {
    return <Error code="404" />;
}
